import PageContent from './components/PageContent'

const List = () => (
  <PageContent />
)

export default List
